
// 测试代码 开始
// require('eruda').init() // 调试工具, 上线前记得注释掉

// import os from '@edu-fe/os'

// os.type = 'weixin'
// os.name = 'weixin'

// 测试代码 结束

import { init } from './main-common'

init({
  baseUrl: process.env.NODE_ENV !== 'development' ? '/wps-h5' : '/'
})
